module.exports = __webpack_public_path__ + "static/media/cert_1.4916e44a.png";